import React, { useState } from "react";
import { Alert, Box, Button, Card, Grid, Icon, Picture, Text } from "~/components-shared";
import { useDispatch, useSelector } from "react-redux";
import { IntegrationTypeEnum } from "~/types/enums";
import themeLight from "~/assets/i/images/theme_light.png";
import themeDark from "~/assets/i/images/theme_dark.png";
import mixpanel from "mixpanel-browser";
import themeContrast from "~/assets/i/images/theme_contrast.png";
import api from "~/lib/api";
import authActionCreators from "~/store/auth/actions";
import { handleError } from "~/lib/helpers";
import lists from "~/lib/lists";
import styled, { useTheme } from "styled-components";
import companySelectors from "~/store/company/selectors";
import { useTranslation } from "react-i18next";
import companyActionCreators from "~/store/company/actions";
const LockIcon = styled(Icon)`
  position: absolute;
  top: 0.8em;
  right: 0.8em;
`;
const PopularIcon = styled(Icon)`
  position: absolute;
  top: 0.8em;
  left: 0.8em;
  z-index: 1;
`;
const freeOptions = [{
  id: 1,
  type: IntegrationTypeEnum.SLACK,
  image: themeLight,
  popular: true
}, {
  id: 2,
  type: IntegrationTypeEnum.JIRA,
  image: themeDark,
  popular: true
}, {
  id: 3,
  type: IntegrationTypeEnum.LINEAR,
  image: themeContrast,
  popular: true
}, {
  id: 4,
  type: IntegrationTypeEnum.ASANA,
  image: themeContrast
}];
const payedOptions = [{
  id: 1,
  type: IntegrationTypeEnum.SALESFORCE,
  image: themeContrast,
  popular: true
}, {
  id: 2,
  type: IntegrationTypeEnum.GITHUB,
  image: themeContrast,
  popular: true
}, {
  id: 3,
  type: IntegrationTypeEnum.NOTION,
  image: themeContrast
}, {
  id: 4,
  type: IntegrationTypeEnum.GOOGLE,
  image: themeContrast
}];
const SignUpOnboardingSelectIntegrations = _ref => {
  let {
    onContinue,
    ...rest
  } = _ref;
  const {
    t
  } = useTranslation();
  const theme = useTheme();
  const company = useSelector(companySelectors.getCompany);
  const [selectedIntegrations, setSelectedIntegrations] = useState(company?.settings.preferredIntegrations || []);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const dispatch = useDispatch();
  const handleSubmit = () => {
    if (selectedIntegrations.length) {
      const data = {
        types: selectedIntegrations
      };
      setLoading(true);
      api.onboardingSelectIntegrations(data).then(_ref2 => {
        let {
          token
        } = _ref2;
        dispatch(authActionCreators.updateTokenStarted(token));
        dispatch(companyActionCreators.fetchStarted());
        mixpanel.track(`SignUp Onboarding (Integrations) – Continue`, {
          ...data
        });
        onContinue();
      }).catch(e => setError(handleError(e))).finally(() => {
        setLoading(false);
      });
    }
  };
  const handleIntegrationSelect = type => {
    if (selectedIntegrations.includes(type)) {
      setSelectedIntegrations(selectedIntegrations.filter(item => item !== type));
    } else {
      setSelectedIntegrations(prev => [...prev, type]);
    }
  };
  const handleMeetJoyn = () => {
    window.open("https://calendly.com/kendra-joyn/30-mins", "_blank");
  };
  return /*#__PURE__*/React.createElement(Card, rest, /*#__PURE__*/React.createElement(Text, {
    fontSize: 5,
    lineHeight: 7,
    align: "center",
    weight: "semiBold",
    s: {
      mb: 8
    }
  }, t("SignUpOnboardingSelectIntegrations.selectIntegrations")), error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 8
    },
    fullWidth: true
  }, error), /*#__PURE__*/React.createElement(Grid, {
    cols: 4,
    gap: 5,
    s: {
      mb: 8
    }
  }, freeOptions.map(option => /*#__PURE__*/React.createElement(Card, {
    key: option.id,
    minHeight: "140px",
    maxWidth: "140px",
    onClick: () => handleIntegrationSelect(option.type),
    fullWidth: true,
    align: "center",
    outline: selectedIntegrations.includes(option.type),
    color: selectedIntegrations.includes(option.type) ? "translucentPrimary" : "background",
    shadow: true
  }, /*#__PURE__*/React.createElement(Picture, {
    width: "48px",
    height: "48px",
    s: {
      mb: 3,
      mt: 3
    },
    src: lists.common.apps.logos(theme)[option.type],
    backgroundSize: "contain"
  }), /*#__PURE__*/React.createElement(Text, {
    weight: "semiBold",
    fontSize: 4,
    color: "text"
  }, lists.integrations.types.names[option.type]), option.popular && /*#__PURE__*/React.createElement(PopularIcon, {
    src: "starFill",
    color: "primary",
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": "Popular"
  })))), /*#__PURE__*/React.createElement(Grid, {
    cols: 2,
    template: "1fr auto",
    fullWidth: true,
    justify: "start",
    align: "center",
    s: {
      mb: 5
    }
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: 4,
    color: "textSecondary",
    weight: "semiBold"
  }, t("SignUpOnboardingSelectIntegrations.paidPlan")), /*#__PURE__*/React.createElement(Button, {
    color: "translucentPrimary",
    s: {
      px: 5,
      py: 2
    },
    onClick: handleMeetJoyn
  }, t("SignUpOnboardingSelectIntegrations.chatSales"))), /*#__PURE__*/React.createElement(Grid, {
    cols: 4,
    gap: 5,
    s: {
      mb: 8
    }
  }, payedOptions.map(option => /*#__PURE__*/React.createElement(Card, {
    key: option.id,
    minHeight: "140px",
    maxWidth: "140px",
    fullWidth: true,
    align: "center",
    outline: selectedIntegrations.includes(option.type),
    color: "grey",
    shadow: true
  }, /*#__PURE__*/React.createElement(Picture, {
    width: "48px",
    height: "48px",
    s: {
      mb: 3,
      mt: 3
    },
    src: lists.members.types.logos(theme)[option.type],
    backgroundSize: "contain"
  }), /*#__PURE__*/React.createElement(Text, {
    weight: "semiBold",
    fontSize: 4,
    color: "text"
  }, lists.integrations.types.names[option.type]), option.popular && /*#__PURE__*/React.createElement(PopularIcon, {
    src: "starFill",
    color: "primary",
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": "Popular"
  }), /*#__PURE__*/React.createElement(LockIcon, {
    src: "lock",
    color: "textSecondary"
  })))), /*#__PURE__*/React.createElement(Box, {
    justify: "center"
  }, /*#__PURE__*/React.createElement(Button, {
    loading: loading,
    disabled: !selectedIntegrations.length,
    onClick: handleSubmit
  }, t("common.actions.saveAndContinue"))));
};
export default SignUpOnboardingSelectIntegrations;